<template>
<div class="page">
    <panel :extinfo="extinfo" ref="panel" :wapTitle="''" :appLink="appLink" :spreadID="'0'" :showNav="false" @gotoApp="gotoApp" :isApp="false"></panel>
    <div class="listHead">
        <div class="titleBox">
            <van-icon @click="goBack()" name="arrow-left" />
        </div>

        <div class="videoBox">
            <video controls="controls" webkit-playsinline='true' x5-video-player-type="h5-page" playsinline='true' :poster="videoDetailObj.cover" :src="videoDetailObj.video_dir"></video>

        </div>

    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
</div>
</template>

<script>
// import {
//     getWXConfig
// } from "@/assets/js/weixinShare";
import {
    scMdFunc,
} from "@/assets/js/scData";
import DownLoadApp from '@/components/common/downloadApp'
import panel from "@/views/preview/component/panel.vue";
import {
    videoDetail
} from "@/api/new";
export default {
    components: {
        DownLoadApp,
        panel
    },
    data() {
        return {
            showDownload: true,
            appLink: '/2/8/0',
            extinfo: '',
            videoDetailObj: {
                video_dir: '',
                cover: ''
            }
        }
    },
    methods: {
        closeDownload() {
            this.showDownload = false
            // this.docH = this.headerH
        },
        gotoApp() {
            
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },

        goBack() {
            if (document.referrer) {
                window.location.href = document.referrer
            } else if (window.history.state) {
                this.$router.back()
            } else if (this.$route.query.fromlink) {
                window.location.href = decodeURIComponent(this.$route.query.fromlink)
            } else {
                this.$router.push({
                    path: "/"
                });
            }
        },
        onLoad() {
            let that = this;
            videoDetail({
                id: this.$route.query.id
            }).then(res => {
                if (res.code === 0) {
                    this.videoDetailObj = res.data
                    scMdFunc('videoPlay', {
                        content_id: that.$route.query.id,
                        content_name: that.videoDetailObj.title,
                        video_type: '视频解读',
                    })
                }
            })
        },

    },
    mounted() {
        this.extinfo=JSON.stringify({url: "videoList",param: ''})
        this.onLoad()

    }
}
</script>

<style lang="scss" scoped>
@import url("../../assets/css/reset.css");

.page {
    background-color: #000;
    height: 100vh;

    .listHead {

        width: 100%;

        .videoBox {
            width: 100%;
            margin-top: 5rem;

            video {
                width: 100%;
                height: 11rem;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }

        }

        .titleBox {
            width: 100%;
            height: 2rem;
            background: #000;
            font-size: 0.7rem;
            line-height: 2rem;
            font-weight: 600;
            color: #fff;
            text-align: left;
            position: relative;
            padding-left: 0.8rem;

            i {
                font-size: 0.9rem;
                line-height: 2rem;
            }
        }

    }

}
</style>
